import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const CERTIFICATIONLEVEL_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.CertificationLevel.Name')
    .required()
    .maxLength(50)
    .build(),
];

export const CERTIFICATIONLEVEL_CONFIG = {
  entityName: 'CertificationLevel',
  localizationKey: 'Planning::Entity.CertificationLevel',
  fields: CERTIFICATIONLEVEL_FIELDS,
  permission: 'Planning.CertificationLevels',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Certification + MENU_NAME_SUFFIX,
};
